import React from 'react'
import calculateStudentGradeLabel from '../../../utilities/calculate-student-grade-label'
import { get, capitalize, startCase } from 'lodash'

const MODES = {
    UPPERCASE: 'UPPERCASE',
    CAPITALIZE: 'CAPITALIZE',
    TITLE: 'TITLE',
}

const processMode = (grade, mode) => {
    switch (mode) {
    case MODES.UPPERCASE:
        return grade ? grade.toUpperCase() : ''
    case MODES.CAPITALIZE:
        return grade ? capitalize(grade) : ''
    case MODES.TITLE:
        return grade ? startCase(grade) : ''
    default:
        return grade
    }
}

const UserGrade = ({
    user = {},
    style = {},
    className = '',
    mode = MODES.UPPERCASE
}) => {
    const grade = processMode(calculateStudentGradeLabel(get(user, 'gradYear')), mode)
    
    return (
        <span style={style} className={className}>
            {grade}
        </span>
    )
}

UserGrade.modes = MODES

export default UserGrade